import { curry } from 'ramda';

import { IAppState } from '../../../AppModulesWrapper';

import { IConfigState } from '../../types/reducers/config';

type TSelectConfigValue = (<K extends keyof IConfigState>(key: K, state: IAppState) => IConfigState[K]) &
  (<K extends keyof IConfigState>(key: K) => (state: IAppState) => IConfigState[K]);

export const selectConfigValue = curry((key: keyof IConfigState, state: IAppState) => {
  return state.servicePickerWidget.config[key];
}) as TSelectConfigValue;
